export const DATABASE_FIELDS_GROUP_NAME = 'databaseFields';
export const DATABASE_FIELDS_GROUP_ID = '__detail_database_fields__';

export function isDatabaseFieldsGroup(group) {
  return group?.detailOnlySource === true || group?.id === DATABASE_FIELDS_GROUP_ID;
}

function normalizedSourceFields(sourceFields, existingKeys) {
  const seen = new Set(existingKeys);
  const fields = [];
  for (const source of sourceFields ?? []) {
    const field = String(source?.field ?? '').trim();
    if (!field || seen.has(field)) continue;
    seen.add(field);
    fields.push({
      field,
      label: String(source?.label ?? '').trim() || field,
      type: String(source?.type ?? '').trim() || 'text',
      show: 1,
      edit: 0,
      req: 0,
      detailOnlySource: true,
    });
  }
  return fields;
}

// Form Groups remain authoritative. Database-discovered fields are appended in
// one marked, detail-only group and duplicates are dropped, so a richer form
// field can never be replaced by inferred metadata.
export function mergeDetailSourceGroups(formGroups, sourceFields) {
  const groups = Array.isArray(formGroups) ? formGroups : [];
  const existingKeys = groups.flatMap((group) => (group.fields ?? []).map((field) => field.field));
  const fields = normalizedSourceFields(sourceFields, existingKeys);
  if (!fields.length) return groups;
  const maxOrder = groups.reduce((max, group) => Math.max(max, Number(group.order) || 0), 0);
  return [
    ...groups,
    {
      id: DATABASE_FIELDS_GROUP_ID,
      name: DATABASE_FIELDS_GROUP_NAME,
      label: 'Database Fields',
      order: maxOrder + 1,
      hideGroupInForm: true,
      detailOnlySource: true,
      fields,
    },
  ];
}

